<template>
  <div>
    <!-- 增加 -->
    <el-button type="primary" @click="add()" class="add">添加</el-button>
    <!-- 关键词和分类查询 -->
    <div class="search">
      <el-input v-model="keyword" placeholder="请输入关键字" class="keyword"></el-input>
      <el-select v-model="newsort" placeholder="请选择">
        <el-option label="全部栏目" value="-1"></el-option>
        <el-option v-for="item in menu" :key="item.id" :label="item.name" :value="item.id"></el-option>
        <el-option v-for="items in classic" :key="items.id" :label="items.name" :value="items.id"></el-option>
      </el-select>
      <el-button type="primary" @click="search()">搜索</el-button>
    </div>
    <!-- 列表显示 -->
    <el-table :data="list" style="width: 100%" border stripe>
      <el-table-column prop="name" label="标题"></el-table-column>
      <el-table-column prop="intro" label="简介"></el-table-column>
      <el-table-column label="封面">
        <template slot-scope="scope">
          <img :src="scope.row.img" alt="">
        </template>
      </el-table-column>
      <el-table-column prop="scene" label="类别"></el-table-column>
      <el-table-column prop="site" label="网址"></el-table-column>
      <el-table-column label="置顶">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.top"
            active-color="#409eff"
            inactive-color="#eee"
            :active-value=1
            :inactive-value=2
            disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.row)"></el-button>
          <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :page-count="pagination.pageCount"
      layout="total,  prev, pager, next, jumper"
      :hide-on-single-page="true"
    ></el-pagination>
    <!-- 具体内容 -->
    <el-dialog title="内容编辑" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="我们的服务">
          <el-select v-model="form.dict_id" placeholder="请选择">
            <el-option
              v-for="item in menu"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经典案例">
          <el-select v-model="form.class_id" placeholder="请选择">
            <el-option
              v-for="item in classic"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="所属分类">-->
<!--          <el-select v-model="value1" multiple placeholder="请选择">-->
<!--            <el-option-group-->
<!--              v-for="group in zmenu"-->
<!--              :key="group.id"-->
<!--              :label="group.title">-->
<!--              <el-option-->
<!--                v-for="item in group.menu"-->
<!--                :key="item.id"-->
<!--                :label="item.title"-->
<!--                :value="item.id">-->
<!--              </el-option>-->
<!--            </el-option-group>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="类别">
          <el-input v-model="form.scene"></el-input>
        </el-form-item>
        <el-form-item label="置顶">
          <el-switch
            v-model="form.top"
            active-color="#409eff"
            inactive-color="#eee"
            :active-value=1
            :inactive-value=2>
          </el-switch>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="form.site"></el-input>
        </el-form-item>
        <el-form-item label="上传封面">
          <el-upload
            class="upload-demo"
            action="/api/uploader"
            :show-file-list="false"
            :on-success="imgsuccess"
            :headers="headers"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <div class="upimg">
            <img v-if="form.img" :src="form.img" alt width="300"/>
          </div>
        </el-form-item>
        <el-form-item label="简介">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.intro"></el-input>
        </el-form-item>
        <el-form-item label="上传二维码">
          <el-upload
            class="upload-demo"
            action="/api/uploader"
            :show-file-list="false"
            :on-success="quickmarksuccess"
            :headers="headers"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <div class="upimg">
            <img v-if="form.code_img" :src="form.code_img" alt width="300"/>
          </div>
        </el-form-item>
        <el-form-item label="轮播图">
          <el-upload
            class="upload-demo"
            action="/api/uploader"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="bannersuccess"
            :file-list="form.banner"
            :headers="headers"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [
          {
            id: 1,
            name: '北京福世达特精密工具有限公司',
            intro: '福世达特专注于搅拌摩擦焊工具-搅拌头的设计、工艺和制造，为用户提供更高效、更稳定的搅拌摩擦焊工具和技术服务。',
            category: '网站优化/网站建设',
            site: 'http://www.fswtool.cn/'
          }
        ],
        dialogVisible: false,
        menu: [
          {id: 11, name: "网站建设"},
        ],
        classic: [
          {id: 101, name: "网站建设"},
        ],
        form: {
          id: 0,
          img: '',
          name: "",
          dict_id: '',
          class_id: '',
          code_img:'',
          scene: '',
          top:2,
          site: '',
          intro: '',
          banner: []
        },
        newsort: "-1",//当前菜单的id
        keyword: "",
        pagination: {
          currentPage: 1,//当前页
          pageSize: 10,//每页的条目数
          total: 10,//总条目数
          pageCount: 1//总页数
        },
        headers: {
          token: window.sessionStorage.getItem("token")
        },
        value1:[],
        zmenu:[
          {
            id:1,
            title:'我们的服务',
            menu:[
              {
                id:11,
                title:'网站建设'
              },
              {
                id:12,
                title:'微信营销'
              },
              {
                id:13,
                title:'软件开发'
              },
              {
                id:14,
                title:'品牌设计'
              },
            ]
          },
          {
            id:2,
            title:'客户案例',
            menu:[
              {
                id:21,
                title:'PC端网站'
              },
              {
                id:22,
                title:'手机端网站'
              },
              {
                id:23,
                title:'微信公众号'
              },
              {
                id:24,
                title:'微信小程序'
              },
              {
                id:25,
                title:'软件系统'
              }
            ]
          } 
        ]
      };
    },
    methods: {
      //数据初始化
      async getcase(page) {
        // console.log(this.newsort)
        var dt = await this.$axios.post('/api/menu', {
          menu: this.newsort,
          page: page,
          search: this.keyword
        })
        dt.data = JSON.parse(dt.data)
        console.log(dt)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.list = dt.data.data.list.data
        this.menu = dt.data.data.menu
        this.classic = dt.data.data.classic
        this.pagination.currentPage = dt.data.data.list.current_page
        this.pagination.total = dt.data.data.list.total
        this.pagination.pageSize = dt.data.data.list.per_page
        this.pagination.pageCount = dt.data.data.list.last_page
      },
      // 单条数据查询
      async handleEdit(val) {
        this.dialogVisible = true;
        var dt = await this.$axios.post('/api/getmenu', {
          menuid: val.id
        })
        dt.data = JSON.parse(dt.data)
        console.log(dt)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.form = dt.data.data
      },
      async handleDelete(val) {
        var dt = await this.$axios.post('/api/deletemenu',{
          id:val.id
        })
        dt.data = JSON.parse(dt.data)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          } else {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        } else {
          alert(dt.statusText)
          return;
        }
        if(this.list.length==1){
          this.getcase(this.pagination.currentPage-1)
        }else{
          this.getcase(this.pagination.currentPage)
        }
      },
      imgsuccess(response, file, fileList) {
        this.form.img = response.data.url
      },
      bannersuccess(response, file, fileList) {
        this.form.banner.push({
          url:response.data.url
        })
        // console.log(this.form.banner)
      },
      quickmarksuccess(response, file, fileList){
        console.log(response)
        this.form.code_img = response.data.url
      },
      add() {
        this.form.id = 0;
        this.form.name = '';
        this.form.intro = '';
        this.form.img = '';
        this.form.top = 2;
        this.form.code_img = '';
        this.form.site = '';
        this.form.dict_id = '';
        this.form.class_id = '';
        this.form.scene = '';
        this.form.banner = [];
        this.dialogVisible = true;
      },
      search() {
        this.getcase(this.pagination.currentPage)
      },
      async save() {
        var dt = await this.$axios.post('/api/amendmenu', this.form)
        dt.data = JSON.parse(dt.data)
        console.log(dt)
        if (dt.status == 200) {
          if(dt.data.code == 3){
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            this.$router.push('/admin/')
            return;
          }else if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }else{
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.dialogVisible = false;
        this.form.id = 0;
        this.form.name = '';
        this.form.intro = '';
        this.form.img = '';
        this.form.top = 1 ;
        this.form.site = '';
        this.form.dict_id = '';
        this.form.class_id = '';
        this.form.scene = '';
        this.form.banner = [];
        this.getcase(this.pagination.currentPage)
      },
      handleCurrentChange(val) {
        this.pagination.currentPage = val
        this.getcase(val)
      },
      handlePreview() {
      },
      //图片删除
      handleRemove(file, fileList) {
        this.form.banner.map(item=>{
          if(item.url == file.url){
            this.form.banner.splice(this.form.banner.indexOf(item),1)
          }
        })
      },

    },
    created() {
      this.getcase(1)
    },
    watch:{
      'value1'(newold,oldval){
        console.log(newold)
      }
    }
  };
</script>

<style lang="less" scoped>
  .add {
    margin-bottom: 20px;
  }

  .conimg {
    width: 35%;
  }

  .keyword {
    width: 20%;
  }

  .search {
    margin-bottom: 20px;
  }

  .upimg {
    margin-top: 20px;
    width: 100% !important;

    img {
      display: inline-block;
      width: 300px;
      margin: 1%;
    }
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-table__row img {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/case.vue